module.exports = __webpack_public_path__ + "static/media/Advance.2cdfee14.svg";